<template>
  <v-system-bar
    v-if="shouldShowBar"
    id="verified-status"
    app
    height="42"
  >
    <v-spacer />
    <span>You have not yet enabled multi-factor authentication. Until you do so
      some functionality will be unavailable.</span>
    <v-btn
      depressed
      small
      :to="{ name: 'manageMfa' }"
    >
      Manage MFA
    </v-btn>
    <v-spacer />
  </v-system-bar>
</template>
<script>
export default {
  name: 'MfaRequiredBanner',
  computed: {
    shouldShowBar: function () {
      return this.user.emailVerified && this.featureEnabled('mfa') && !this.mfaEnabled
    }
  },
  beforeCreate() {
    this.mapGetters(['featureEnabled'])
    this.mapStates(['user', 'mfaEnabled'])
  }
}
</script>

<style>
#verified-status {
  background-color: rgb(250, 227, 180);
  color: black;
}
#verified-status span {
  padding-right: 0.75em;
}
</style>
